module.exports = __webpack_public_path__ + "static/media/Gallery-2.e5dd41a7.jpg";